<template>
  <div class="lucky-page" :style="{ backgroundImage: 'url(' + xylp_background + ')' }">
    <div class="my-body">
      <div
        class="heightBG"
        :style="{ height: boxHeightRem + 'rem' }"
      >
        <div class="top-back">
          <div class="top-login-box">
            <div class="not-login" @click="logFun" v-if="!isLogin">
              <div data-text="登录" >登录</div>
            </div>
            <div class="logined" v-else>
                <div class="name">
                  <span>
                    <a-icon type="user"  class="icon-before" style="font-size: x-small;" />
                  </span>
                  <span :data-full-text="info.username" @click="toggleText">{{ truncateText(info.username) }}</span>
                </div>
                <div class="logout" @click="logOut"></div>
            </div>
          </div>
          <img :src="xylp_logo" class="logoImg" />
        </div>
        <div class="hegithBottom">
          <div class="roulette">
            <div class="circleBox">
              <div
                id="prizeCircle"
                class="prizeCircle"
                :style="rotate"
              >
                <div
                  class="fanBox"
                  :key="ii"
                  v-for="(its, ii) in hongbaolist"
                  :class="['fanBox' + ii, 'fanBox' + Number(its.money_to), hongbaolist.length % 2 === 0 ? 'fanBoxOdd' : 'fanBoxEven']"
                >
                  <div
                    class="fan"
                    :style="'transform: rotate(' + getRote(hongbaolist.length, ii) + 'deg) skew(' + getRote3(hongbaolist.length) + 'deg);'"
                    :class="{ 'fanOdd': ii % 2 == 0, 'fanEven': ii % 2 != 0 }"
                  ></div>
                  <div
                    class="prizeTxt"
                    :class="{ 'prizeTxtOdd': ii % 2 == 0, 'prizeTxtEven': ii % 2 != 0 }"
                    :style="'transform: rotate(' + getRote2(hongbaolist.length, ii) + 'deg);'"
                  >
                 <span>{{ Number(its.money_to) }}</span>
                </div>
                </div>
              </div>
            </div>
            <div
              class="point"
              @click="spinFun"
            ></div>
          </div>
          <!-- show count -->
          <div class="remain-count" v-show="isLogin">
             剩余&nbsp;{{ remain || 0 }}&nbsp;次
          </div>

        </div>
      </div>

     <!-- 底部 -->
      <div class="bottom-box">
        <div class="bottom-box-top">
          <div @click="logFun">抽奖记录</div>
          <span>|</span>
          <div>
            <a :href="onLink" target="_bank">联系客服</a>
          </div>
        </div>
      </div>
    </div>


    <loading
      v-show="loading"
      class="loadingClass"
    />
    <transition name="fade">
      <Login v-show="showLoginModal" @close="closeModal" @customAlert="customAlert"/>
    </transition>
    <transition name="fade">
        <Final v-show="showFinalModal" @close="closeModal" :amount="amount" :isWin="isWin"/>
    </transition>
    <transition name="fade">
        <DrawTimes v-if="showLogModal" @close="closeModal"/>
    </transition>   
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loading from './LoadingModule.vue'
import DrawTimes from './DrawTimes.vue';
import Final from './FinalModule.vue';
import Login from './LoginModule.vue';
export default {
  data() {
    return {
      rotate: '',
      activeindex: null,
      number: 0,
      jishu: 0,
      id: '',
      price: 0,
      infoShow: false,
      infoText: '',
      commaShow: false,
      imgUrl: '',
      tagShow: 1,
      shoplist: [],


      hongbaolist: [],
      remain: 0,
      showLoginModal: false, // 是否登录
      isLogin: false,
      showFinalModal: false,  // 抽奖弹框
      showLogModal: false, // 抽奖记录弹框
      onLink: '',
      info: '',
      amount: 0, // 旋转结果
      isWin: false,
      xylp_logo: '',
      xylp_background: ''
    };
  },
  computed: {
    ...mapGetters(['loading']),
    boxHeightRem() {
      return this.innerHeightRem;
    },
  },
  components: {
    Loading,
    Login,
    Final,
    DrawTimes
  },
  mounted() {
    this.siteInitFun()
    this.checkActivityFun()
    this.poolFun()
    let _info = sessionStorage.getItem('info')
    if (_info) {
      this.getDetailFun()
    }
  },
  methods: {
    customAlert  (content, title, width, top)  {
      if (content == undefined) {
        content = "";
      }
      if (title == undefined) {
        title = "温馨提示";
      }
      if (width == undefined) {
        width = "360px";
      }
      if (top == undefined) {
        top = "50%";
      }
      this.$modal.confirm({
        title: title,
        content: content,
        okText: '确定',
        cancelText: '取消'
      });
    },
    closeModal(visible) {
      if (visible === 'showLoginModal') {
        let _info = sessionStorage.getItem('info')
        if (_info) {
          this.isLogin = true
          this.info = JSON.parse(_info)
          this.remain = this.info.total_draw_times
        }
      }
      this[visible] = false
    },
    async poolFun() {
      this.$store.dispatch('SET_LOADING', true)
      await this.$axios.post("/XYLPWinningPool/getAllList", {}).then(r => {
        if (r.status === 200) {
          const { status, msg } = r.data
          if (status) {
            const { list } = r.data.data
            this.hongbaolist = list
          } else this.errorFun(msg)
        }
      }).catch(() => {
      });
      this.$store.dispatch('SET_LOADING', false)
    },
    async siteInitFun() {
      this.$store.dispatch('SET_LOADING', true)
      await this.$axios.post("/Site/init", {}).then(r => {
        if (r.status === 200) {
          const { status, msg } = r.data
          if (status) {
            const { cs_url, xylp_logo, xylp_background, name } = r.data.data
            this.onLink = cs_url
            this.xylp_logo = this.$Domain + xylp_logo
            this.xylp_background = this.$Domain + xylp_background
            document.title = `${name}-幸运轮盘`
            this.handleIcoCreate(this.xylp_logo)
          } else this.errorFun(msg)
        }
      }).catch(() => {
      });
      this.$store.dispatch('SET_LOADING', false)
    },
    handleIcoCreate(icoUrl) {
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = icoUrl
      document.getElementsByTagName('head')[0].appendChild(link);
    }, 
    async checkActivityFun() {
      this.$store.dispatch('SET_LOADING', true)
      await this.$axios.post("/XYLPUser/checkActivity", {}).then(r => {
        if (r.status === 200) {
          const { status, msg } = r.data
          if (status) {
            const { cs_url } = r.data.data
            this.onLink = cs_url
          } else this.errorFun(msg)
        }
      }).catch(() => {
      });
      this.$store.dispatch('SET_LOADING', false)
    },
    async spinFun() {
      if (!this.isLogin) {
        this.showLoginModal = true
      } else {
        if (this.rotate.indexOf('transform') !== -1) {
          return;
        }
        // eslint-disable-next-line no-console
        console.log(this.loading);
        this.$store.dispatch('SET_LOADING', true)
        await this.$axios.post('/XYLPUser/spin', { username: this.info.username }).then((r) => {
          if (r.status === 200) {
            const { status, msg } = r.data
            if (status) {
              const { total_draw_times, money, winning_pool_id } = r.data.data
              this.remain = total_draw_times


              let ii = 5;
              let flag2 = false;
              for (let key in this.hongbaolist) {
                if (this.hongbaolist[key].id === winning_pool_id) {
                  ii = key;
                  if (Number(money) > 0) {
                    flag2 = true;
                  }
                }
              }
              let dataromote =
                -(360 / this.hongbaolist.length) * parseInt(ii) -
                360 / this.hongbaolist.length / 2 -
                1800;
              this.rotate =
                'transform: rotate(' +
                dataromote +
                'deg);-webkit-transform: rotate(' +
                dataromote +
                'deg);-moz-transform:rotate(' +
                dataromote +
                'deg)';
              setTimeout(() => {
                let _el = document.getElementsByClassName('fanBox'+ii)[0]
                _el.classList.add('winner-bg')  
                if (flag2) {
                  this.amount = Number(money)
                  this.isWin = true
                  setTimeout(() => {
                    this.showFinalModal = true
                  }, 300);
                } else {
                  this.amount = 0
                  this.isWin = false
                  setTimeout(() => {
                    this.showFinalModal = true
                  }, 300);
                }
                setTimeout(() => {
                  _el.classList.remove('winner-bg')
                  this.rotate = '';
                  }, 300);
              }, 3 * 1000);
            } else this.errorFun(msg)
          }
        })
        this.$store.dispatch('SET_LOADING', false)
      }
    },
    async getDetailFun() {
      this.$store.dispatch('SET_LOADING', true)
      let username = this.userNameFun()
      if (!username) return
      await this.$axios.post('/XYLPUser/getDetail', { username: username }).then((r) => {
        if (r.status === 200) {
          const { status, msg } = r.data
          if (status) {
            this.isLogin = true
            sessionStorage.setItem('info', JSON.stringify(r.data.data))
            this.info = r.data.data
            this.remain = r.data.data.total_draw_times
          } else this.errorFun(msg)
        }
      })
      this.$store.dispatch('SET_LOADING', false)
    },
    userNameFun() {
      let _info = sessionStorage.getItem('info')
      if (_info) {
        this.isLogin = true
        let temp = JSON.parse(_info)
        return temp.username
      }
      return ''
    },
    logFun() {
      if (!this.isLogin) {
        this.showLoginModal = true
      } else this.showLogModal = true
    },
    errorFun(msg) {
      this.$message.error(msg)
    },
    logOut() {
      sessionStorage.clear();
      location.reload();
    },
    truncateText(text) {
      if(!text) return
      const maxLength = 8;
      if (text.length > maxLength) {
        return text.substring(0, maxLength) + "...";
      }
      return text;
    },
    toggleText(element) {
      const span = element.currentTarget
      const fullText = span.getAttribute('data-full-text');
      // Check if the current text ends with "..."
      if (span.textContent.endsWith('...')) {
        // If it's truncated, show the full text
        span.textContent = fullText;
      } else {
        // If it's not truncated, show the truncated version
        span.textContent = this.truncateText(fullText);
      }
    }
  },

  watch: {
  }
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  -moz-user-select: none;
  /*火狐*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -ms-user-select: none;
  /*IE10*/
  -khtml-user-select: none;
  /*早期浏览器*/
  user-select: none;
}

p {
  margin: 0;
  padding: 0;
}

a {
  color: #fff;
}

::-webkit-scrollbar {
  width: 0 !important;
}


.lucky-page {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #bf0419;
  background-position: center top;
  background-repeat: no-repeat;
  background-size: 100% auto;

  .my-body {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .bottom-box {
    position: fixed;
    bottom: 0;
    width: 3.75rem;
    height: .44rem;
    line-height: .44rem;
    flex-shrink: 0;
    border-top: 1px solid #FF8D8C;
    background: rgba(191, 0, 26, 0.90);

    .bottom-box-top {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-content: center;
    
        >div {
          width: 40%;
          text-align: center;
          color: #FFF;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
        }
    
        span {
          color: #FFF;
        }
      }
  }

  p {
    margin: 0;
    padding: 0;
  }

  .heightBG {
    position: relative;
    width: 100%;
    background-size: 100% 100%;

    .top-back {
      position: relative;
      height: 1.5rem;
      text-align: center;
      line-height: 0;
      .top-login-box {
        padding: 10px;
        display: flex;
        justify-content: flex-end;
      }

      .not-login {
        width: 101px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        background: url(~@/assets/not.png) no-repeat center top;
        background-size: 100% auto;


        div {

          font-family: 'Signika Negative SC';
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 17px;
          text-align: center;
          text-transform: capitalize;

          /* 渐变文字 */
          background: linear-gradient(179.82deg, #8E0001 0.15%, #FA0104 59.05%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-fill-color: transparent;

          /* 布局 */
          display: inline-flex;
          align-items: flex-end;
          position: relative;
          padding: 5px;
          /* 给边框留出空间 */

        }

        div::before {
          content: attr(data-text);
          position: absolute;
          top: 5px;
          left: 0;
          right: 0;
          bottom: 0;
          /* 边框效果 */
          color: transparent;
          -webkit-text-stroke: 0.3px rgba(255, 255, 255, 0.7);
          text-stroke: 0.3px rgba(255, 255, 255, 0.7);
        }
      }
      .logined {
        width: 100%;
        color: #fff;
        display: flex;
        align-content: center;
        justify-content: space-between;
        gap: 10px;

        .name {
          box-sizing: border-box;
          min-width: 109px;
          height: 34px;
          line-height: 34px;
          padding: 0 10px;
          background: rgba(0, 0, 0, 0.5);
          border: 1px solid rgba(255, 255, 255, 0.5);
          border-radius: 100px;
          z-index: 99;

          span:first-child {
            display: inline-block;
            width: 18px;
            height: 18px;
            line-height: 16px;
            text-align: center;
            border-radius: 50%;
            background-color: #d41d13;
          }
        }
        span:last-child{
          padding-left: 5px;
        }
      }

      .logout {
        width: 38px;
        height: 38px;
        background: url(~@/assets/out.png) no-repeat center top;
        background-size: 100% auto;
      }
      img{
        position: absolute;
        top: 5px;
        left: 0;
        right: 0;
        display: inline-block;
        width: 1.2rem;
        height: auto;
        margin: 0 auto;
        vertical-align: text-top;
        object-fit: contain;
      }
    }
  }

  .hegithBottom {
    width: 100%;
    padding-top: 0.4rem;
    padding-bottom: 1em;
    background-size: 100% 100%;

    .remain-count {
      margin: 0.1rem auto 0 auto;
      text-align: center;
      font-family: MicrosoftYaHei;


      border-radius: 20px;
      border: 1px solid rgba(255, 255, 255, 0.80);
      background: rgba(191, 0, 26, 0.60);
      min-width: .96rem;
      max-width: max-content;
      padding: 0 .1rem;
      height: .32rem;
      line-height: .32rem;

      color: #FFF;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 15px;
      font-style: normal;
      font-weight: 500;


    }

    .click-toLink {
      width: 76%;
      height: 0.82rem;
      padding: 0 0.3rem;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      // background: url(../assets/img/bigWheel/m_click_bottom.png) no-repeat;
      background-size: 100% 100%;

      div {
        height: 0.4rem;
        margin: auto 0;
      }

      .win-record {
        // background: url(../assets/img/bigWheel/m_win_record.png) no-repeat;
        background-size: 100% 100%;
      }

      .buy-point {
        // background: url(../assets/img/bigWheel/m_buy_point.png) no-repeat;
        background-size: 100% 100%;
      }

      .show-rules {
        // background: url(../assets/img/bigWheel/m_rules.png) no-repeat;
        background-size: 100% 100%;
      }
    }
  }

  .roulette {
    position: relative;
    background: url(../assets/img/bigWheel/zp.png) no-repeat center center;
    width: 3.65rem;
    height: 3.65rem;
    margin: 0 auto;
    max-width: 3.65rem;
    max-height: 3.65rem;
    background-size: contain;
    padding: .4rem;

    .point {
      margin: auto;
      width: 0.7rem;
      height: 1rem;
      position: absolute;
      left: 0.03rem;
      right: 0;
      top: 0;
      bottom: 0.3rem;
      background: url('./../assets/img/bigWheel/point.png') no-repeat bottom;
      cursor: pointer;
      background-size: contain;
    }

    .circleBox {
      width: 100%;
      height: 100%;
      overflow: hidden;
      cursor: pointer;
      position: relative;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      border-top-left-radius: 9.99rem;
      border-top-right-radius: 9.99rem;
      border-bottom-right-radius: 9.99rem;
      border-bottom-left-radius: 9.99rem;
      border-radius: 10rem;

      .prizeCircle {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        border-top-left-radius: 9.99rem;
        border-top-right-radius: 9.99rem;
        border-bottom-right-radius: 9.99rem;
        border-bottom-left-radius: 9.99rem;
        border-radius: 10rem;
        width: 100%;
        height: 100%;
        -webkit-transition: 2.7s;
        transition: 2.7s;
        overflow: hidden;

        .fanBox {
          .fan {
            margin: 0;
            width: 50%;
            height: 50%;
            position: absolute;
            -webkit-transform-origin: 100% 100%;
            transform-origin: 100% 100%;
            color: #fff;
            font-size: 0.5rem;
          }

          .fanOdd {
            background: linear-gradient(202deg, #FFDA86 16.89%, #FCA965 49.18%);
          }

          .fanEven {
            background: #FEF4D9;
          }

          .prizeTxtOdd {
            color: #fff;
          }

          .prizeTxtEven {
            color: #F87201;
          }

          .prizeTxt {
            font-family: Reklame Script;
            font-size: 24px;
            font-weight: 500;

            position: absolute;
            width: 30%;
            height: 95%;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            margin: auto;
            text-align: center;
          }
        }

        .winner-bg {
          >div:first-child{
            background: linear-gradient(180deg, #EE3945 0%, #FB8B71 100%);
          }
          .prizeTxt{
            color: #fff;
          }
        }
        .fanBox18888,.fanBox1888{
            span {
                display: inline-block;
                transform: rotate(270deg);
                padding-right: 19px;
              }
        }
        .fanBoxEven:first-child {
          >div:first-child{
            background: #fff;
          }
          .prizeTxt {
            color: #F87201;
          }
        }
      }
    }
  }

}
</style>
